// extracted by mini-css-extract-plugin
export default {"goals":"TutorDetailGoals_goals__p7pzT","goalsList":"TutorDetailGoals_goalsList__n63Lg"};